import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="pb-12 lg:pb-100">
      <div className="container">
        <div className="text-center pb-6 lg:py-60">
          <h3 className="title pb-5 tab:pb-30 border-b border-border_sec">
            Privacy Policy
          </h3>
        </div>
        <div className="grid gap-8 [&_li]:text-gray [&_ul]:list-disc [&_ul]:ps-7 [&_li]:mb-1">
          <h6 className="text-base">
            GuideProAI ("we," "our," or "us") values your privacy. This Privacy
            Policy outlines how we collect, use, and protect your personal
            information when you use our platform.
          </h6>
          <div className="grid gap-3">
            <p className="font-semibold">1. Information We Collect</p>
            <ul>
              <li>
                Personal Information: Name, email address, phone number, company
                details, and payment information.
              </li>
              <li>
                Usage Data: Device type, browser type, IP address, and activity
                logs.
              </li>
              <li>
                Uploaded Data: Documents, files, or other content you upload to
                use our services.
              </li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">2. How We Use Your Information</p>
            <ul>
              <li>To provide and improve our services.</li>
              <li>
                For account creation, authentication, and customer support.
              </li>
              <li>
                To communicate updates, promotions, and service-related
                information.
              </li>
              <li>To comply with legal obligations.</li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">3. Data Sharing and Security</p>
            <ul>
              <li>
                AWe may share information with third-party service providers for
                operational purposes (e.g., payment processors, analytics).
              </li>
              <li>
                We implement encryption and other security measures to protect
                your data.
              </li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">4. Your Rights</p>
            <ul>
              <li>Access, correct, or delete your personal data.</li>
              <li>Opt-out of marketing communications.</li>
              <li>Request a copy of your data.</li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">5. Retention of Data</p>
            <ul>
              <li>
                WWe retain data only as long as necessary for legitimate
                business or legal purposes.
              </li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">6. Cookies</p>
            <ul>
              <li>
                We use cookies to enhance your experience. You can manage cookie
                preferences through your browser settings.
              </li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">7. Changes to This Policy</p>
            <ul>
              <li>
                We may update this policy periodically. Changes will be notified
                via email or on our website.
              </li>
            </ul>
          </div>
          <div className="grid gap-3">
            <p className="font-semibold">8. Contact Us</p>
            <ul>
              <li>If you have questions, email us at info@guideproai.com.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
